import React from 'react';
import { motion } from 'framer-motion';
import { PhoneIcon } from 'lucide-react';
export function ContactBand() {
  return <section id="contact" className="w-full bg-ardis-green py-16" data-id="element-36" data-mp="1pxseovhclg41">
      <motion.div initial={{
      opacity: 0,
      y: 24
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-60px'
    }} transition={{
      duration: 0.5
    }} className="mx-auto flex max-w-4xl flex-col items-center gap-6 px-4 text-center sm:px-6 lg:px-8" data-id="element-37" data-mp="1bztzxoz47ho0">
        <h2 className="font-display text-3xl font-extrabold text-white sm:text-4xl" data-id="element-38" data-mp="t9m2nni3jlfq">
          Vragen? Neem contact met ons op
        </h2>
        <p className="max-w-2xl text-white/80" data-id="element-39" data-mp="y85o7mss2v7k">
          Ons team staat klaar om u te adviseren en uw groothandelsbestelling
          voor te bereiden. Neem vandaag nog contact met ons op.
        </p>
        <a href="tel:+32480205930" className="inline-flex items-center gap-2 rounded-full bg-ardis-yellow px-7 py-3.5 text-sm font-semibold text-ardis-green-dark shadow-lg transition-transform hover:-translate-y-0.5 hover:bg-yellow-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-ardis-green" data-id="element-40" data-mp="o8ygbf4tbsru">
          <PhoneIcon className="h-4 w-4" data-id="element-41" data-mp="2ya2fqb7c1m7h" />
          Bel ons
        </a>
      </motion.div>
    </section>;
}